import { OrganizationService } from '../../organizations/organization.service';
import { ItemService } from '../../items/item.service';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { Observable, of } from 'rxjs';
import { switchMap, map, take, delay } from 'rxjs/operators';

export class SKUValidator {
  static createValidator(
    orgService: OrganizationService,
    itemService: ItemService,
    itemId?: string,
  ): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors> => {
      if (!control.value) {
        return of(null);
      }

      return of(control.value).pipe(
        delay(300),
        switchMap(() => orgService.active),
        take(1),
        switchMap((org) => {
          if (!org) {
            return of(0);
          } else {
            const query: any = {
              SKU: control.value,
            };

            if (itemId) {
              query.id = { neq: itemId };
            }

            return itemService.count(org.id, query);
          }
        }),
        map((res) => (res < 1 ? null : { notUnique: true })),
      );
    };
  }
}
